enum ConstituentSortFields {
  DISPLAY_NAME = 'display_name',
  LAST_INTERACTION_DATE = 'last_interaction_date',
}

export default ConstituentSortFields;
